export const CAMPAIGN_STATUS = {
  public: '公開中',
  private: '下書き',
}
